'use strict';

/*global services*/

function Tests() {
  this.modal = null;
  this.data = null;

  this.init();
}

Tests.prototype = $.extend({}, {
  constructor: 'Tests',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.test-keyboard', function () {
      _this.testKeyboard();

      return false;
    });

    $('body').on('keyup change', '.test-keyboard__input', function (e) {
      _this.appendKeyboardInput(e);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  testKeyboard: function testKeyboard() {
    var _this = this;

    var modal = services.get('modal');
    modal.open({
      content: '<input type="text" class="test-keyboard__input form-control" /><div class="test-keyboard__show"></div>'
    });

    setTimeout(function () {
      modal.setFocus(true);
    }, 500);

    return _this;
  },

  appendKeyboardInput: function appendKeyboardInput(e) {
    var _this = this;

    e = e || window.event;
    var keyCode = e.keyCode || e.which;

    var $input = '<div class="test-keyboard__key-code">' + keyCode + '</div>';

    var modal = services.get('modal');
    modal.contentDOM().find('.test-keyboard__show').append($input);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
